import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

const DynamicTable = ({
  data,
  skipColumns,
  headers,
  height,
  width,
  showHeaders = true,
}) => {
  console.log("data", data);

  if (!skipColumns) {
    skipColumns = [];
  }
  const [tableHeaders, setTableHeaders] = useState([]);
  useEffect(() => {
    if (headers && headers.length > 0) {
      setTableHeaders((prev) => headers);
      return;
    }
    if (data && data.length) {
      if (headers && headers.length) {
        setTableHeaders(headers);
        return;
      }
      setTableHeaders(
        Object.keys(data[0]).filter((key) => skipColumns.indexOf(key) === -1)
      );
    }
  }, [data, headers]);

  const getValue = (data, key) => {
    console.log(data, key);
    if (data === 0 || data === "0") return data;

    if (data === null || data === undefined || data === "") {
      return "";
    }

    // value string or number
    const numericValue = data;

    if (!isNaN(numericValue)) {
      // if string is whole or not
      const isWholeNumber =
        Number.isInteger(numericValue) ||
        (typeof numericValue === "string" &&
          numericValue.includes(".") === false);

      // if whole return direclty
      return numericValue;
    }

    // returning original value

    return data;
  };

  return (
    <TableContainer overflowY="auto" mt="1rem" maxH={height} w="100%">
      <Table size="sm">
        {showHeaders && (
          <Thead position="sticky" top="0" zIndex="sticky">
            <Tr bg="#1a174e">
              {tableHeaders?.map((elem, idx) => (
                <Th
                  p="10px"
                  key={idx}
                  color="white"
                  fontSize="15px"
                  textTransform="uppercase"
                  fontWeight={400}
                >
                  {elem}
                </Th>
              ))}
            </Tr>
          </Thead>
        )}
        <Tbody>
          {data &&
            data.length > 0 &&
            data?.map((item, i) => (
              <Tr key={i}>
                {tableHeaders?.map((key, j) => (
                  <Td key={i + "-" + j}>{getValue(item[key], key)}</Td>
                ))}
              </Tr>
            ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default DynamicTable;
